import React from 'react';
import styles from './styles.module.scss';

interface ComponentProps extends React.HTMLAttributes<HTMLButtonElement> {
  text: string;
}

export const TextButton: React.FC<ComponentProps> = ({text = '' , ...rest}): JSX.Element => {
  return (
    <span
      className={styles.textButton}
      role='button'
      tabIndex={0}
      {...rest}
    >
      {text}
      </span>
  );
};
